// src/pages/Contact.js
import './Contact.css';
import { useEffect, useRef, useState} from 'react';
import { useLocation } from 'react-router-dom';
import emailjs from 'emailjs-com';

export default function Contact() {
  const location = useLocation();
  const formRef = useRef(null);
  const [status, setStatus] = useState('');
  useEffect(() => {
    if (location.hash === '#contact-form') {
      const el = document.getElementById('contact-form');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);
  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('Sending...');

    emailjs.sendForm(
      'service_pfqjsng', // Your service ID
      'template_5nqqwor', // Your template ID
      formRef.current,
      'm_ZtWJyKVOKYjyuJV' // Replace with your actual public key
    )
    .then(() => {
      setStatus('Message sent successfully!');
      formRef.current.reset();
    })
    .catch((error) => {
      console.error('Email send failed:', error);
      setStatus('Failed to send message.');
    });
  };
  return (
    <div className="contact-container">
      <h1>Get in Touch</h1>
      <p className="intro">
        Have questions, custom requests, or need help with your photobook?
        Our team is here to assist you with care, speed, and creativity.
      </p>

      {/* Why Contact Us */}
      <div className="why-contact">
        <h2>Why Reach Out?</h2>
        <ul>
          <li><strong>Free Design Consultation:</strong> Not sure where to start? Let us guide you.</li>
          <li><strong>Custom Order Assistance:</strong> Want something unique? We’re happy to help.</li>
          <li><strong>Support & Questions:</strong> Need help with shipping, orders, or design? We’re a message away.</li>
        </ul>
      </div>

      {/* Contact Details & Map */}
      <div className="contact-details">
        <div className="info">
          <h2>Visit or Call Us</h2>
          <p>
            <strong>WePrint PhotoBooks</strong><br />
            #37, Sannidhi Rd, NR Colony,<br />
            Basavanagudi, Bengaluru,<br />
            Karnataka 560004, India
          </p>

          <h3>Phone</h3>
          <p><a href="tel:+918861494444">+91 88614 94444</a></p>

          <h3>Email</h3>
          <p><a href="mailto:info@weprintphotobooks.com">info@weprintphotobooks.com</a></p>

          <h3>Working Hours</h3>
          <p>Mon – Sat: 10:00 AM – 7:00 PM<br />Sunday: Closed</p>
        </div>

        <div className="map"  id="contact-form">
        <iframe
          title="WePrint PhotoBooks Directions"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.0925608139364!2d77.5697979!3d12.9397701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1545de14a951%3A0x5f9c01dd10f3259!2sWePrint%20PhotoBooks%2C%20%2337%2C%20Sannidhi%20Rd%2C%20NR%20Colony%2C%20Basavanagudi%2C%20Bengaluru%2C%20Karnataka%20560004%2C%20India!5e0!3m2!1sen!2sin!4v1721313540144!5m2!1sen!2sin"
          width="100%"
          height="350"
          style={{ border: 0, borderRadius: '12px' }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
        </div>
      </div>
      <div className="whatsapp-chat">
        <p>Prefer chatting? Reach us instantly:</p>
        <a
          href="https://wa.me/8861494444"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button"
        >
          💬 Chat with us on WhatsApp
        </a>
      </div>

      {/* Contact Form */}
      <div className="contact-form">
        <h2>Send us a Message</h2>
        <p className="form-intro">Fill in the form below and we’ll get back to you within 1 business day.</p>
        <form ref={formRef} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Your Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <input type="phone" name="phone" placeholder="Your Phone Number" required />
          <textarea name="message" placeholder="Your Message" rows="5" required></textarea>
          <button type="submit">Send Message</button>
        </form>
        {status && <p className="form-status">{status}</p>}
      </div>
    </div>
  );
}
